import React, {useState, useEffect} from 'react';
import {mrbgStore} from './mrbgRedux/index.js';
import MrbgPanelHeader from './MrbgPanelHeader.jsx';
import MrbgAside from './MrbgAside.jsx';
import BillAmount from '../BillAmount.jsx';
import MrbgFormsList from './MrbgFormsList.jsx';
import asideStyle from '../../static/css/MP_aside.module.css';
import headerStyle from '../../static/css/MP_header.module.css';
import formStyle from '../../static/css/MP_forms.module.css'
import TimeLinePopUp from '../TimeLinePopUp.jsx';
import MrbgLoader from './MrbgLoader.jsx';
import MrbgFullPopup from './MrbgFullPopup.jsx';
import MrbgHumanDefineArea from './MrbgHumanDefineArea.jsx';
import MrbgHumanSelectArea from './MrbgHumanSelectArea.jsx';
import MrbgDataList from './MrbgDataList.jsx';
import MrbgSvgDefs from './MrbgSvgDefs.jsx';
import MrbgSpecialDateTimeLinePopUp from './MrbgSpecialDateTimeLinePopUp.jsx'
import MrbgTimeLineUpd_DT from './MrbgTimeLineUpd_DT.jsx'
import ManageInputs from '../ManageInputs.jsx'
import SetOperator from '../SetOperator.jsx'

function MrbgPanel({formsJsKey,readySettings,MP_mainStyle}){

  const
    [hideMenu,setHideMenu] = useState(mrbgStore.getState().device==='mob'? true: false),
    [themeColor,setThemeColor] = useState(mrbgStore.getState().mrbgVars.__TC),
    [semiThemeColor,setSemiThemeColor] = useState(mrbgStore.getState().mrbgVars.__STC),
    formsList = Object.values(mrbgStore.getState().mrbgVars.formsList);

  document.documentElement.setAttribute( 'lang', 'fa' );
  document.documentElement.querySelector('title').innerText = mrbgStore.getState().enTitle.replace(/\b\w/g, char => char.toUpperCase());
  if( themeColor ){
    document.documentElement.style.setProperty('var(--MP_TC)' , themeColor);
    document.documentElement.style.setProperty('--STC', semiThemeColor);
  }

  useEffect(()=>{
    if( !hideMenu && mrbgStore.getState().device==='mob' ){
      function mobMenuClick(e){
        if(
          (!e.target.closest(`#${asideStyle.sideMenu}`) || e.target.classList.contains(asideStyle.elypsisItem)) &&
          !e.target.closest(`#${headerStyle.mrbgMenuIcon}`)
        ){
          setHideMenu(true);
          document.removeEventListener('click',mobMenuClick);
        }
      }
      document.addEventListener('click', mobMenuClick);
    }
  },[hideMenu])
  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setThemeColor    ( mrbgStore.getState().mrbgVars.__TC  )
      setSemiThemeColor( mrbgStore.getState().mrbgVars.__STC )
    });
    return () =>unsubscribe();
  },[]);

  return(
    <main id={MP_mainStyle.panelMain}>
      <MrbgPanelHeader {...{hideMenu,setHideMenu,headerStyle}}/>
      <MrbgSvgDefs {...{formStyle}}/>
      {formsJsKey? <MrbgAside {...{hideMenu,formsJsKey,readySettings,asideStyle}}/>: ''}
      {formsJsKey? <MrbgFormsList {...{hideMenu,formsJsKey,readySettings,formStyle}}/>: ''}
      <MrbgDataList />
      {
        (formsList.intersect(['apoRes','apoResUpd'])).length?
          <>
            <BillAmount />
            <MrbgHumanSelectArea />
            <TimeLinePopUp />
            {
              readySettings && Object.hasOwn(readySettings,'specialDate')?
                <MrbgSpecialDateTimeLinePopUp {...{formsJsKey,formStyle}}/>:
                ''
            }
            {
              readySettings && Object.hasOwn(readySettings,'timeLineUpd_DT')?
                <MrbgTimeLineUpd_DT {...{formsJsKey,formStyle}}/>:
                ''
            }
          </>:
          ''
      }
      {
        (formsList.intersect(['are','areUpd','arePac'])).length?
          <MrbgHumanDefineArea />:
          ''
      }
      <MrbgFullPopup {...{MP_mainStyle}}/>
      <MrbgLoader />
      <ManageInputs />
      <SetOperator />
    </main>
  )
}

export default MrbgPanel;